import gql from 'graphql-tag';

import tokenFragment from '../fragments/tokenFragment';

export const mutationCreateAccount = gql`
  mutation createAccount (
    $accountType: AccountType
    $enabledFeatures: [String!]
    $password: String
    $primaryEmail: String!
    $primaryFirstName: String
    $primaryLastName: String
    $origin: String
    $utmSource: String
    $utmMedium: String
    $utmCampaign: String
    $utmTerm: String
    $utmContent: String
  ) {
    createAccount (
      accountType: $accountType
      enabledFeatures: $enabledFeatures
      password: $password
      primaryEmail: $primaryEmail
      primaryFirstName: $primaryFirstName
      primaryLastName: $primaryLastName
      origin: $origin
      utmSource: $utmSource
      utmMedium: $utmMedium
      utmCampaign: $utmCampaign
      utmTerm: $utmTerm
      utmContent: $utmContent
    ) {
      ...tokenFragment
    }
  }
  ${tokenFragment}
`;
export default mutationCreateAccount;
